import React, {useEffect} from "react";
import {Form, Row, Col, Input, Button, Spin, Select} from 'antd';
import {Trans} from "@lingui/macro";
import {useAxios} from "../../utils/hooks";
import {AxiosResponse, AxiosError} from 'axios';
import {openNotification} from '../../utils/openNotification';
import useSafeState from '../../utils/safe-state';

interface Interface {
    data?: any;
    onClose?: () => void;
}

const CertificateEditDrawer = (props: Interface) => {

    const [form] = Form.useForm();
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [loading, setLoading] = useSafeState(false);

    useEffect(() => {
        form.resetFields();
        if (props.data) {
            form.setFieldsValue({
                rollNumber: props.data.rollNumber,
                manufacturerName: props.data.manufacturerName,
                manufacturerId: props.data.manufacturerId,
                certificateLink: props.data.certificateLink,
                certificateQuality: props.data.certificateQuality,
            });
        }
    }, []);

    const handleSave = () => {
        if (axiosInstance.current != null) {
            setLoading(true);
            const payload = {
                rollNumber: form.getFieldValue('rollNumber'),
                manufacturerName: form.getFieldValue('manufacturerName'),
                manufacturerId: form.getFieldValue('manufacturerId'),
                certificateLink: form.getFieldValue('certificateLink'),
                certificateQuality: form.getFieldValue('certificateQuality'),
            };
            axiosInstance.current
                .put('/resource/stock/update-certificate', payload)
                .then(function (response: AxiosResponse<any>) {
                    openNotification('success', '');
                    setLoading(false);
                    if (props.onClose) props.onClose();
                })
                .catch(function (error: AxiosError) {
                    let errResp = JSON.parse(JSON.stringify(error.response));
                    let errMessage = errResp.data.message;
                    openNotification('error', errMessage);
                    setLoading(false);
                });
        }
    };

    return (
        <Form layout="vertical" form={form}>
            <Spin spinning={loading} />
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item
                        name="rollNumber"
                        label={<Trans>Roll Number</Trans>}
                        children={<Input disabled />}
                    />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item
                        name="manufacturerName"
                        label={<Trans>Manufacturer Name</Trans>}
                        children={<Input />}
                    />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item
                        name="manufacturerId"
                        label={<Trans>Manufacturer ID</Trans>}
                        children={<Input />}
                    />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item
                        name="certificateLink"
                        label={<Trans>Certificate Link</Trans>}
                        children={<Input />}
                    />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item
                        name="certificateQuality"
                        label={<Trans>Minősítés</Trans>}
                        children={
                            <Select allowClear style={{width: '100%'}}>
                                <Select.Option value="MEGFELELO">Megfelelő</Select.Option>
                                <Select.Option value="NEM_MEGFELELO">Nem megfelelő</Select.Option>
                                <Select.Option value="HIANYOS">Hiányos</Select.Option>
                            </Select>
                        }
                    />
                </Col>
            </Row>
            <Button loading={loading} type="primary" onClick={handleSave}>
                <Trans>Mentés</Trans>
            </Button>
        </Form>
    );
};

export default CertificateEditDrawer;
